import React from 'react';
import { Loader } from 'freemium-ui';
import { History } from 'history';
import { useHistory } from 'react-router-dom';
import { useGetContactList } from 'routes/screens/lists/hooks';
import { useGetSegment } from 'routes/screens/segments/hooks';
import { ContactListType, SegmentType } from 'shared/types';

type RespondedFromProps = {
  id: string;
  type: 'list' | 'segment';
};

const RespondedFrom = (props: RespondedFromProps) => {
  const { id, type } = props;
  const history: History = useHistory();
  const [data, setData] = React.useState<{ name: string; deleted: boolean }>();
  const {
    refetch: refetchContactList,
    isFetching: isFetchingContactList,
    isError: isContactListError,
  } = useGetContactList({
    showDeleted: true,
    contactListId: type === 'list' ? id || '' : '',
    callback: (isSuccess: boolean, response: ContactListType) => {
      if (isSuccess) {
        setData({
          name: response?.name || response.label || '',
          deleted: !!response?.deleted,
        });
      }
    },
  });

  const {
    refetch: refetchSegment,
    isFetching: isFetchingSegment,
    isError: isSegmentError,
  } = useGetSegment({
    showDeleted: true,
    segmentId: type === 'segment' ? id || '' : '',
    callback: (isSuccess: boolean, response: SegmentType) => {
      if (isSuccess) {
        setData({
          name: response.name || '',
          deleted: !response.id,
        });
      }
    },
  });

  React.useEffect(() => {
    if (!type || !id) return;
    if (type === 'list') {
      refetchContactList();
      return;
    }
    if (type === 'segment') {
      refetchSegment();
      return;
    }
  }, [type, id]);

  if (isFetchingContactList || isFetchingSegment) {
    return (
      <div key={id} className="item">
        <Loader size="small" />
      </div>
    );
  }

  if (isContactListError || isSegmentError) {
    return (
      <div key={id} className="item">
        {`Deleted ${type}`}
      </div>
    );
  }

  return (
    <div
      key={id}
      className={`item ${data?.deleted ? '' : 'link'}`.trim()}
      onClick={() => {
        if (data?.deleted) return;
        history.push(type === 'list' ? `/lists/${id}` : `/segments/${id}/edit`);
      }}
    >
      {data?.name || ''}
    </div>
  );
};

export default RespondedFrom;
